import React, {PureComponent} from 'react';
import {ReactSVG} from 'react-svg';
import PropTypes from 'prop-types';
import moment from 'moment';

import downloadIcon from '../../images/download.svg';

import {
  ActionButton,
  DownloadButton,
  Date,
  ItemProp,
  ItemPropValue,
  Items,
  OrderId,
  OrderItem,
  OrderRow,
  OrderWrapper,
  RowTitle,
  Total,
  ReOrder,
  ItemPropNonLink,
  RequestButton,
} from './OrdersPage.style';

import {isServiceItem} from '../../helpers/basket.helper';
import {ORDER_HISTORY_DATE_FORMAT} from '../../constants/constants';
import {Loading} from '../../components/Loading/Loading';

export default class Invoice extends PureComponent {
  static propTypes = {
    invoices: PropTypes.array,
    reOrder: PropTypes.func,
  };

  state = {
    detailsOpen: false,
    isDownloading: false,
  };

  componentDidUpdate(props) {
    const {invoices, downloadingStatus} = this.props;
    if (
      downloadingStatus &&
      invoices &&
      invoices[0] &&
      invoices[0].salesId &&
      downloadingStatus[invoices[0].salesId] === false
    ) {
      this.setState({isDownloading: false});
    }
  }

  openClose = () => {
    this.setState({detailsOpen: !this.state.detailsOpen});
  };

  doReOrder = () => {
    const {invoices, reOrder} = this.props;
    if (invoices && invoices.length > 0) {
      reOrder(invoices[0].salesId);
    }
  };

  // Every invoice of the order combined into one document, for the download button.
  orderPdfUrl = () => {
    const links = this.props.invoices[0] && this.props.invoices[0]._links;
    return (
      links &&
      ((links['order-pdf'] && links['order-pdf'].href) ||
        (links.pdf && links.pdf.href))
    );
  };

  // Opens the invoice. A part-invoiced order has one document per part, so it offers
  // the parts to choose from instead — no download starts here, so no spinner either.
  viewPdf = e => {
    e && e.preventDefault();
    const {auth, invoices, viewPdf, downloadPdf} = this.props;
    if (!auth || !window) {
      return;
    }
    if (invoices.length > 1) {
      viewPdf(invoices);
      return;
    }
    const links = invoices[0] && invoices[0]._links;
    this.setState({isDownloading: true});
    downloadPdf(
      links && links.pdf && links.pdf.href,
      auth.access_token,
      0,
      invoices[0].salesId,
      false
    );
  };

  downloadPdf = e => {
    e && e.preventDefault();
    const {auth, invoices, downloadPdf} = this.props;
    if (!auth || !window) {
      return;
    }
    this.setState({isDownloading: true});
    downloadPdf(
      this.orderPdfUrl(),
      auth.access_token,
      0,
      invoices[0].salesId,
      true
    );
  };

  navToOrder = () => {
    const {invoices, goToOrder} = this.props;
    const isInvoiced = true;
    goToOrder(invoices[0].salesId, {setRefundMode: true}, isInvoiced);
  };

  render() {
    const {invoices, downloadingStatus} = this.props;
    const {isDownloading} = this.state;
    // A part-invoiced order carries one entry per part, so the order total is the
    // sum of its invoices.
    const invoicesTotal = invoices
      .reduce((total, invoice) => total + (invoice.invoiceTotal || 0), 0)
      .toFixed(2);
    const renderDetails =
      this.state.detailsOpen &&
      invoices.map((invoice, index) => {
        const renderItems =
          invoice.items &&
          invoice.items.length > 0 &&
          invoice.items.map((item, i) => {
            const isSameDayDelivery = isServiceItem(item);
            const orderItem = isSameDayDelivery
              ? item.itemName || item.itemId
              : `${item.itemId} ${item.itemName && ' - ' + item.itemName} x ${
                  item.quantityInvoiced
                }`;

            const renderOrderItem = isSameDayDelivery ? (
              <ItemPropNonLink>{orderItem}</ItemPropNonLink>
            ) : (
              <ItemProp href={`/productDetail/${item.itemId}`}>
                {orderItem}
              </ItemProp>
            );
            return (
              <OrderItem key={item.itemId + i}>
                {renderOrderItem}
                <ItemPropValue>£{item.linePrice}</ItemPropValue>
              </OrderItem>
            );
          });
        return (
          <Items key={invoice.invoiceId || index}>
            Invoice {invoice.invoiceId || index + 1} <br />
            {renderItems}
          </Items>
        );
      });

    const renderDetailsButton = this.state.detailsOpen ? 'hide' : 'view';
    const viewInvoicesButtonText = isDownloading ? (
      <Loading isLight={false} />
    ) : invoices.length === 1 ? (
      'View invoice'
    ) : (
      'View invoices'
    );

    const renderInvoicedOrderDescription = (
      <ActionButton onClick={this.viewPdf}>
        {viewInvoicesButtonText}
      </ActionButton>
    );
    const renderInvoicedOrderDownload = (
      <DownloadButton onClick={this.downloadPdf}>
        <ReactSVG src={downloadIcon} />
      </DownloadButton>
    );
    const renderInvoiceDate = moment(invoices[0].invoiceDateTime).format(
      ORDER_HISTORY_DATE_FORMAT
    );

    const renderReOrderLink = (
      <ReOrder onClick={this.doReOrder}>Reorder these items</ReOrder>
    );
    // Parts of one order can be invoiced days apart, so the order is still
    // refundable while any of its invoices is inside the refund window.
    const renderRequestBtn = invoices &&
      invoices.some(invoice => !!invoice.couldBeRefunded) && (
        <RequestButton onClick={this.navToOrder}>Request Refund</RequestButton>
      );
    return (
      <OrderWrapper key={invoices[0].salesId}>
        <OrderRow>
          <OrderId>
            <RowTitle>Order</RowTitle> {invoices[0].salesId}
          </OrderId>
          <Total>£{invoicesTotal}</Total>
          <ActionButton $isshort onClick={this.openClose}>
            {renderDetailsButton}
          </ActionButton>
          {renderInvoicedOrderDescription}
          {renderInvoicedOrderDownload}
          <Date>
            <RowTitle>Invoiced on {renderInvoiceDate}</RowTitle>
            {renderReOrderLink}
          </Date>
          {renderRequestBtn}
        </OrderRow>
        {renderDetails}
      </OrderWrapper>
    );
  }
}
